// eslint-disable-next-line import/no-cycle
import request from '..';
import { RequestOptions, RequestResponse } from '../types';
import isBrowser from '../../is-browser';
import { uriParse } from '../utils';

export function requestCSRF(options: RequestOptions) {
  if (!isBrowser) return options;

  const opts = options;
  const CSRFToken = window.sessionStorage.getItem('X-CSRF-Token');
  if (CSRFToken) {
    opts.headers['X-CSRF-Token'] = CSRFToken;
  }
  return options;
}

// 浏览器端 处理 CSRF 重新发请求
export function responseCSRF(response: RequestResponse) {
  if (!isBrowser) return response;

  const options = response.config;

  if (response.status === 204) {
    const CSRFToken = response.headers['x-csrf-token'];
    window.sessionStorage.setItem('X-CSRF-Token', CSRFToken);
    options.headers['X-CSRF-Retry'] = '1';
    options.headers['X-CSRF-Token'] = CSRFToken;
    const url = uriParse(options.url).pathname;
    return request({ ...options, url });
  }
  return response;
}
